<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import Multiselect from 'vue-multiselect';
import Swal from '@/utils/ugm-swal';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader , FormWizard, TabContent, Multiselect},
    data() {
        return {
            title: "Digitalizar encuesta",
            items: [
                {
                text: "Digitalizar",
                href: "/"
                },
                {
                text: "Digitar encuesta",
                active: true
                }
            ],
            isLoading: false,
            imagenes:[],
            datos:{
                rut:'',
                fecha:'',
                dia_nacimiento:'',
                mes_nacimiento:'',
                anio_nacimiento:'',
                nombres:'',
                apellido_paterno:'',
                apellido_materno:'',
                nombre_colegio:'',
                curso:'',
                celular:'',
                email:'',
                carrera:null,
                es_pasaporte: false
            },
            rotacionFrontal: 0, // Nueva propiedad para la rotación
            rotacionAtras: 0, // Nueva propiedad para la rotación
            colegioseleccionada: null,
            datoscolegios: [],
            currentStep: 1,
            carreras: [
                { codigo: 'USC1318', nombre: 'Administración Pública', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UME153', nombre: 'Agronomía', sede: 'Melipilla', comuna: 'Santiago' },
                { codigo: 'UPR153', nombre: 'Agronomía', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UPR1103', nombre: 'Animación Digital', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UPR160', nombre: 'Arquitectura', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC174', nombre: 'Comunicación Audiovisual y Multimedia', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UPR161', nombre: 'Construcción Civil', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC159', nombre: 'Contador Auditor', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO156', nombre: 'Derecho', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'UPR156', nombre: 'Derecho', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC156', nombre: 'Derecho', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL156', nombre: 'Derecho', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UPR1644', nombre: 'Diseño', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC166', nombre: 'Educación Parvularia', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO1157', nombre: 'Enfermería', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF1157', nombre: 'Enfermería', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UMP1157', nombre: 'Enfermería', sede: 'Maipú', comuna: 'Santiago' },
                { codigo: 'UPR1157', nombre: 'Enfermería', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC1157', nombre: 'Enfermería', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL1157', nombre: 'Enfermería', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UCO1203', nombre: 'Fonoaudiología', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'UPR1203', nombre: 'Fonoaudiología', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL1203', nombre: 'Fonoaudiología', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UPR1623', nombre: 'Gastronomía y Negocios Gastronómicos', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC154', nombre: 'Ingeniería Civil Industrial', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UPR1652', nombre: 'Ingeniería Comercial', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UCO1652', nombre: 'Ingeniería Comercial', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF1652', nombre: 'Ingeniería Comercial', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UVL1652', nombre: 'Ingeniería Comercial', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'USC1681', nombre: 'Ingeniería en Informática', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO1112', nombre: 'Kinesiología', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF1112', nombre: 'Kinesiología', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UMP1112', nombre: 'Kinesiología', sede: 'Maipú', comuna: 'Santiago' },
                { codigo: 'UPR1112', nombre: 'Kinesiología', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC1112', nombre: 'Kinesiología', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL1112', nombre: 'Kinesiología', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UPR1294', nombre: 'Licenciatura en Ciencias de la Actividad Física', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UCO163', nombre: 'Medicina Veterinaria', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF163', nombre: 'Medicina Veterinaria', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UME163', nombre: 'Medicina Veterinaria', sede: 'Melipilla', comuna: 'Santiago' },
                { codigo: 'UMP163', nombre: 'Medicina Veterinaria', sede: 'Maipú', comuna: 'Santiago' },
                { codigo: 'UPR163', nombre: 'Medicina Veterinaria', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC163', nombre: 'Medicina Veterinaria', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL163', nombre: 'Medicina Veterinaria', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UPR1132', nombre: 'Nutrición y Dietética', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL1132', nombre: 'Nutrición y Dietética', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UCO1132', nombre: 'Nutrición y Dietética', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'USC1132', nombre: 'Nutrición y Dietética', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UPR1422', nombre: 'Obstetricia y Puericultura', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL1422', nombre: 'Obstetricia y Puericultura', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'USC167', nombre: 'Pedagogía en Educación Básica', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'USC1149', nombre: 'Pedagogía en Educación Diferencial', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'USC168', nombre: 'Pedagogía en Educación Física', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'USC165', nombre: 'Periodismo', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO158', nombre: 'Psicología', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF158', nombre: 'Psicología', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UMP158', nombre: 'Psicología', sede: 'Maipú', comuna: 'Santiago' },
                { codigo: 'UPR158', nombre: 'Psicología', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC158', nombre: 'Psicología', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL158', nombre: 'Psicología', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UCO1204', nombre: 'Terapia Ocupacional', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'UPR1204', nombre: 'Terapia Ocupacional', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL1204', nombre: 'Terapia Ocupacional', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'USC1135', nombre: 'Trabajo Social', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO195', nombre: 'Traducción e Interpretación en Inglés', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'UPR195', nombre: 'Traducción e Interpretación en Inglés', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL195', nombre: 'Traducción e Interpretación en Inglés', sede: 'Viña del Mar', comuna: 'Viña del Mar' }
            ],
            carrerasFiltradas: [],
            ruterror:'',
            searchTimeout: null,
            colegioQuery: '',
            cropTop: 100 // px a ocultar desde arriba
        };
    },
    props: {
        evento_id: {
            type: [String, Number],
            required: false
        },
        laborante_id: {
            type: [String, Number],
            required: false
        }
    },
    computed: {
    },
    watch: {},

    mounted() {
        this.cargarImagenesSinRevisar();
        console.log(this.imagenes[1]?.url_publica);
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.datoscolegios = response.data.colegios;
            }
        }
        ).catch(error => console.error(error)
        ).finally(() => this.isLoading = false);
        this.carrerasFiltradas = this.carreras;
    },
    methods:{
        onComplete() {
            const datosEnviar = {
                rut: this.datos.rut,
                fecha: this.datos.fecha,
                dia_nacimiento: this.datos.dia_nacimiento,
                mes_nacimiento: this.datos.mes_nacimiento,
                anio_nacimiento: this.datos.anio_nacimiento,
                nombre_completo: this.datos.nombre_completo || '',
                nombres: this.datos.nombres || '',
                apellido_paterno: this.datos.apellido_paterno || '',
                apellido_materno: this.datos.apellido_materno || '',
                nombre_colegio: this.datos.nombre_colegio || '',
                curso: this.datos.curso || '',
                celular: this.datos.celular || '',
                email: this.datos.email || '',
                carrera: this.datos.carrera?.codigo || '',
                evento_id: this.evento_id,
                rbd_colegio: this.colegioseleccionada?.rbd || '',
                laborante_id: this.laborante_id,
                id_imagen: this.imagenes[0]?.id || null,
                id_imagen2: this.imagenes[1]?.id || null,
            };

            this.isLoading = true;
            axios.post('/api/actualizar_imagen_revisada', datosEnviar)
                .then(response => {
                    const data = response.data || {};

                    // Si el backend indica error (por ejemplo campos faltantes en CRM)
                    if (!data.estado) {
                        const mensaje = data.mensaje || 'Error';
                        let errores = [];
                        if (mensaje.includes('- El atributo')) {
                            errores = mensaje
                                .split('- El atributo')
                                .slice(1)
                                .map(e => e.trim().replace(/\[|\]/g, ''))
                                .filter(Boolean);
                        }
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al enviar los datos al CRM',
                            html: errores.length
                                ? `<div style="font-weight:bold;color:#d9534f;">Faltan datos:</div>
                                <ul style="margin-left:1em;color:#333;">${errores.map(e => `<li>${e}</li>`).join('')}</ul>`
                                : mensaje,
                            confirmButtonText: 'Cerrar'
                        });
                        return;
                    }

                    // Éxito: actualizar lista de imágenes y poblar datos (si hay)
                    this.imagenes = data.imagenes || [];
                    console.log(`Imagenes por revisar: ${this.imagenes.length}`);
                    if (this.imagenes.length === 0) {
                        this.$bvToast.toast('No hay más imágenes para revisar, redireccionando...', {
                            title: 'Información',
                            variant: 'info',
                            solid: true
                        });
                        setTimeout(() => {
                            window.location.href = '/web/digitalizar/asociar';
                        }, 3000);
                        return;
                    }

                    const img0 = this.imagenes[0];
                    this.datos.rut = img0?.rut || '';
                    this.datos.fecha = (img0?.fecha || '').replace(/\s+/g, '').toUpperCase();
                    const partes = this.datos.fecha.split('-');
                    this.datos.dia_nacimiento = partes[0] || '';
                    this.datos.mes_nacimiento = partes[1] || '';
                    this.datos.anio_nacimiento = partes[2] || '';
                    this.datos.nombres = (img0?.nombres || '').toUpperCase();
                    this.datos.apellido_paterno = (img0?.apellido_paterno || '').toUpperCase();
                    this.datos.apellido_materno = (img0?.apellido_materno || '').toUpperCase();
                    this.datos.nombre_colegio = (img0?.establecimiento || '').toUpperCase();
                    this.datos.rbd_colegio = '';
                    this.datos.celular = (img0?.celular || '').replace(/\s+/g, '').toUpperCase();
                    this.datos.email = (img0?.email || '').replace(/\s+/g, '').toUpperCase();
                    this.datos.carrera = null;
                    this.datos.sede = null;

                    this.$bvToast.toast('Datos enviados correctamente', {
                        title: 'Éxito',
                        variant: 'success',
                        solid: true
                    });
                    this.$refs.formWizard.reset();
                })
                .catch(error => {
                    console.error(error);
                    if (error.response && error.response.status === 413) {
                        Swal.fire('Error', 'Archivo demasiado grande para el servidor (413).');
                    } else {
                        this.$bvToast.toast('Error al enviar los datos', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        cargarImagenesSinRevisar() {
            this.isLoading = true;
            axios.get('/api/imagenes_digitalizadas', {
                params: {
                    evento_id: this.evento_id,
                    laborante_id: this.laborante_id,
                    estado: 'sin_revisar'
                }
            })
            .then(response => {
                this.imagenes = response.data.imagenes || [];
                console.log(`Imagenes por revisar: ${this.imagenes.length}`);
                this.isLoading = false;
                if(this.imagenes.length === 0) {
                    this.$bvToast.toast('No hay más imágenes para revisar, redireccionando...', {
                        title: 'Información',
                        variant: 'info',
                        solid: true
                    });
                    // redireccionar a /web/digitalizar/asociar despues de 3 seg
                    setTimeout(() => {
                        window.location.href = '/web/digitalizar/asociar';
                    }, 3000);
                }
                // Solo las 2 primeras
                console.log(this.imagenes[0]);
                this.datos.rut = this.imagenes[0]?.rut || '';
                this.datos.fecha = (this.imagenes[0]?.fecha || '').replace(/\s+/g, '').toUpperCase();
                const partes = this.datos.fecha.split('-');
                this.datos.dia_nacimiento = partes[0] || '';
                this.datos.mes_nacimiento = partes[1] || '';
                this.datos.anio_nacimiento = partes[2] || '';
                this.datos.nombres = (this.imagenes[0]?.nombres || '').toUpperCase();
                this.datos.apellido_paterno = (this.imagenes[0]?.apellido_paterno || '').toUpperCase();
                this.datos.apellido_materno = (this.imagenes[0]?.apellido_materno || '').toUpperCase();
                this.datos.nombre_colegio = (this.imagenes[0]?.establecimiento || '').toUpperCase();
                this.datos.celular = (this.imagenes[0]?.celular || '').replace(/\s+/g, '').toUpperCase();
                this.datos.email = (this.imagenes[0]?.email || '').replace(/\s+/g, '').toUpperCase();
                console.log('cargarImagenesSinRevisar');
                console.log(this.datos);
                this.isLoading = false;
                
            })
            .catch(error => {
                console.error('Error al cargar imágenes:', error);
                this.isLoading = false;
            });
        },
        customLabel(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        fetchColegios(query) {
            // Limpiar timeout anterior
            clearTimeout(this.searchTimeout);
            
            // Si no hay query o es muy corta, no buscar
            if (!query || query.trim().length < 3) {
                return;
            }

            // Esperar 500ms después de que el usuario deje de escribir
            this.searchTimeout = setTimeout(() => {
                this.isLoading = true;
                axios.get(`/api/colegios?search=${query}`)
                    .then(response => {
                        this.datoscolegios = response.data;
                    })
                    .catch(error => console.error(error))
                    .finally(() => this.isLoading = false);
            }, 500);
        },
        handleStepChange(prevIndex, nextIndex) {
        this.currentStep = nextIndex + 1; // los pasos comienzan desde 0
        },
        carreraLabel(option) {
            if (!option) return '';
            return `${option.nombre} (${option.codigo})`;
        },
        formatRut() {
            // 1. Dejar solo números y k
            let cleanRut = this.datos.rut.replace(/[^0-9kK]/g, "").toUpperCase();

            // 2. Limitar largo máximo: 8 dígitos + dígito verificador (total 9)
            if (cleanRut.length > 9) {
                cleanRut = cleanRut.slice(0, 9);
            }

            // 3. Si hay más de un carácter, separar cuerpo y DV
            if (cleanRut.length > 1) {
                const body = cleanRut.slice(0, -1);
                const dv = cleanRut.slice(-1);

                // 4. Asignar sin puntos y con guion
                this.datos.rut = `${body}-${dv}`;
            } else {
                // Si es solo 1 carácter, se deja tal cual
                this.datos.rut = cleanRut;
            }
        },
        cleanRut(value) {
            return value.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
        },
        validateRut() {
            // Si es pasaporte, no validar
            if (this.datos.es_pasaporte) {
                this.ruterror = '';
                return;
            }

            let rut = this.cleanRut(this.datos.rut);
            if (!rut) {
                this.ruterror = 'RUT inválido';
                return;
            }

            let digito_verificador = this.datos.rut.slice(-1).toUpperCase();
            rut = rut.slice(0, rut.length - 1);

            let suma = 0;
            let multiplo = 2;

            for (let i = rut.length - 1; i >= 0; i--) {
                suma += parseInt(rut.charAt(i)) * multiplo;
                multiplo = multiplo < 7 ? multiplo + 1 : 2;
            }

            let dv_calculado = 11 - (suma % 11);
            if (dv_calculado === 11) dv_calculado = '0';
            else if (dv_calculado === 10) dv_calculado = 'K';
            else dv_calculado = dv_calculado.toString();

            if (digito_verificador !== dv_calculado) {
                this.ruterror = 'RUT inválido';
            } else {
                this.ruterror = '';
            }
        },
        antesdecambiar() {
            // 1. Validar error previo
            if (this.ruterror != '') {
                this.$toasted.error("El Rut no es válido");
                return false;
            }
            // 2. Validar que el RUT esté en formato sin puntos y con guion
            //    Ejemplo válido: 12345678-9  o  11111111-K
            const rutFormatoCorrecto = /^\d{1,8}-[\dkK]$/;
            if (!rutFormatoCorrecto.test(this.datos.rut)) {
                this.$toasted.error("El formato del RUT debe ser sin puntos y con guion (Ej: 11111111-1)");
                return false;
            }
            // 3. Si todo está OK
            return true;
        },
        async cortar() {
            // Obtener el contenedor y la imagen actuales
            const contenedor = this.currentStep === 1 ? this.$refs.container1 : this.$refs.container2;
            const img = this.currentStep === 1 ? this.$refs.image1 : this.$refs.image2;

            if (!contenedor || !img) return;

            // Calcular el rectángulo visible de la imagen
            const rect = contenedor.getBoundingClientRect();
            const imgRect = img.getBoundingClientRect();

            // Calcular el centro del contenedor
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            // Calcular el centro de la imagen
            const imgCenterX = imgRect.left + imgRect.width / 2;
            const imgCenterY = imgRect.top + imgRect.height / 2;

            // Calcular el factor de escala (suponiendo que queremos un cuadrado de 300x300px)
            const scale = 300 / Math.min(rect.width, rect.height);

            // Calcular el nuevo tamaño de la imagen
            const newWidth = imgRect.width * scale;
            const newHeight = imgRect.height * scale;

            // Calcular la posición de la imagen recortada
            const cropX = centerX - imgCenterX;
            const cropY = centerY - imgCenterY;

            // Aplicar el recorte (usando CSS para simplificar)
            img.style.width = `${newWidth}px`;
            img.style.height = `${newHeight}px`;
            img.style.objectFit = 'cover';
            img.style.objectPosition = `${-cropX}px ${-cropY}px`;
        },

        // Descarta el par completo de imágenes (delantera + trasera) y carga el siguiente par
        async descartarYPasar() {
            // Siempre usamos la primera imagen (delantera) ya que el backend elimina el par completo
            const imagen = this.imagenes[0];
            if (!imagen || !imagen.id) {
                this.$bvToast.toast('No hay imágenes para descartar', { title: 'Error', variant: 'danger', solid: true });
                return;
            }
    
            const confirmar = await Swal.fire({
                title: 'Confirmar descartado',
                text: '¿Deseas descartar este par de imágenes (delantera + trasera) y pasar al siguiente?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, descartar',
                cancelButtonText: 'Cancelar'
            });
            if (!confirmar.isConfirmed) return;
    
            this.isLoading = true;
            try {
                const payload = { id_imagen: imagen.id };
                const resp = await axios.post('/api/descartar_imagen', payload);
    
                // Si el backend devuelve lista actualizada de imágenes la usamos
                if (resp.data && resp.data.imagenes) {
                    this.imagenes = resp.data.imagenes || [];
                    
                    // Si no hay más imágenes, redirigir
                    if (this.imagenes.length === 0) {
                        this.$bvToast.toast('No hay más imágenes para revisar, redireccionando...', {
                            title: 'Información',
                            variant: 'info',
                            solid: true
                        });
                        setTimeout(() => {
                            window.location.href = '/web/digitalizar/asociar';
                        }, 3000);
                        return;
                    }
                    
                    // Cargar datos de la nueva primera imagen
                    const img0 = this.imagenes[0];
                    this.datos.rut = img0?.rut || '';
                    this.datos.fecha = (img0?.fecha || '').replace(/\s+/g, '').toUpperCase();
                    const partes = this.datos.fecha.split('-');
                    this.datos.dia_nacimiento = partes[0] || '';
                    this.datos.mes_nacimiento = partes[1] || '';
                    this.datos.anio_nacimiento = partes[2] || '';
                    this.datos.nombres = (img0?.nombres || '').toUpperCase();
                    this.datos.apellido_paterno = (img0?.apellido_paterno || '').toUpperCase();
                    this.datos.apellido_materno = (img0?.apellido_materno || '').toUpperCase();
                    this.datos.nombre_colegio = (img0?.establecimiento || '').toUpperCase();
                    this.datos.celular = (img0?.celular || '').replace(/\s+/g, '').toUpperCase();
                    this.datos.email = (img0?.email || '').replace(/\s+/g, '').toUpperCase();
                    this.datos.carrera = null;
                    this.colegioseleccionada = null;
                }
    
                // Resetear formulario al primer paso
                if (this.$refs.formWizard && this.$refs.formWizard.reset) {
                    this.$refs.formWizard.reset();
                }
                this.currentStep = 1;
    
                this.$bvToast.toast('Par de imágenes descartado correctamente', { 
                    title: 'Éxito', 
                    variant: 'success', 
                    solid: true 
                });
            } catch (err) {
                console.error('Error descartando imagen:', err);
                this.$bvToast.toast('Error al descartar las imágenes', { 
                    title: 'Error', 
                    variant: 'danger', 
                    solid: true 
                });
            } finally {
                this.isLoading = false;
            }
        },
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card mi-card pb-4 mb-4 shadow-lg" style="height: auto;">
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-scan font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Digitalizar Encuesta</h5>
                            <small class="text-white" style="opacity:.8;">Escanea y procesa encuestas con OCR</small>
                        </div>
                    </div>
                    <div class="card-body text-center">
                        <div class="row">
                            <div class="col-md-6">
                                <!-- Imagen Frontal: visible siempre -->
                                <div v-if="imagenes[0]!=''" v-show="currentStep === 1">
                                    <h5>Imagen Frontal:</h5>
                                    <div class="image-container1" ref="container1">
                                        <img ref="image1" :src="imagenes[0]?.url_publica" alt="Foto1" :style="{ transform: 'rotate(' + rotacionFrontal + 'deg)' }"/>
                                    </div>
                                </div>
                                <!-- Imagen Atrás: solo visible en paso 4 o al finalizar -->
                                <div v-if="imagenes[1] != ''" v-show="currentStep === 2">
                                    <h5>Imagen Atrás:</h5>
                                    <div class="image-container2" ref="container2">
                                        <!-- <img ref="image2" :src="imagenes[1]?.url_publica" alt="Foto2" :style="{ transform: 'rotate(' + rotacionAtras + 'deg)' }"/> -->
                                        <img ref="image2" :src="imagenes[1]?.url_publica" alt="Foto2"
                                            :style="{ transform: 'translateY(-' + cropTop + 'px) rotate(' + rotacionAtras + 'deg)' }"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <b-button variant="outline-danger" class="mr-2" @click="descartarYPasar">
                                    <i class="bx bx-trash"></i> Descartar y siguiente
                                </b-button>
                                 <!-- <h5 class="text-secondary">Revisa los datos a continuación, si están correctos presiona "Siguiente", en caso contrario modificalos y luego presiona "Siguiente".</h5> -->
                                 <form-wizard
                                 color="#C87838"
                                 @on-complete="onComplete"
                                 @on-change="handleStepChange"
                                 title=""
                                 subtitle=""
                                 nextButtonText="Siguiente" 
                                 backButtonText="Atrás" 
                                 finishButtonText="Finalizar"
                                 ref="formWizard"
                                 >
                                    <tab-content title="Datos personales" :before-change="antesdecambiar">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Rut / Pasaporte:</label>
                                                    <b-form-input
                                                        v-model="datos.rut"
                                                        :class="ruterror && !datos.es_pasaporte ? 'input-error' : 'border-primary'"
                                                        @blur="validateRut"
                                                        @input="formatRut"
                                                    ></b-form-input>
                                                    <p v-if="!datos.es_pasaporte">Debe ser sin puntos y con guión</p>
                                                    <p v-if="ruterror && !datos.es_pasaporte" class="error text-danger">{{ ruterror }}</p>
                                                    <b-form-checkbox 
                                                        v-model="datos.es_pasaporte"
                                                        class="mt-2"
                                                    >
                                                        Documento extranjero (Pasaporte)
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-6 d-flex justify-content-center">
                                                <div class="form-group text-center">
                                                    <label for="fecha">Fecha de Nacimiento:</label>
                                                    <div class="d-flex justify-content-center ">
                                                        <b-form-input
                                                            v-model="datos.dia_nacimiento"
                                                            class="border-primary text-center "
                                                            placeholder="DD"
                                                            maxlength="2"
                                                            style="width: 70px;"
                                                        ></b-form-input>
                                                        <b-form-input
                                                            v-model="datos.mes_nacimiento"
                                                            class="border-primary text-center "
                                                            placeholder="MM"
                                                            maxlength="2"
                                                            style="width: 70px;"
                                                        ></b-form-input>
                                                        <b-form-input
                                                            v-model="datos.anio_nacimiento"
                                                            class="border-primary text-center"
                                                            placeholder="AAAA"
                                                            maxlength="4"
                                                            style="width: 90px;"
                                                        ></b-form-input>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Nombres:</label>
                                                    <b-form-input v-model="datos.nombres" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Apellido Paterno:</label>
                                                    <b-form-input v-model="datos.apellido_paterno" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Apellido Materno:</label>
                                                    <b-form-input v-model="datos.apellido_materno" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Celular:</label>
                                                    <b-form-input v-model="datos.celular" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> E-mail:</label>
                                                    <b-form-input v-model="datos.email" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-8">
                                                <div class="form-group">
                                                    <label for="pais"> Nombre del Establecimiento Educacional:</label>
                                                    <b-form-input v-model="datos.nombre_colegio" class="border-primary mb-2"></b-form-input>
                                                    <multiselect
                                                        v-model="colegioseleccionada"
                                                        :options="datoscolegios"
                                                        :searchable="true"
                                                        :loading="isLoading"
                                                        :custom-label="customLabel"
                                                        placeholder="Buscar colegio..."
                                                        @search-change="fetchColegios"
                                                        selectLabel="Presiona para seleccionar"
                                                        selectedLabel="Seleccionado"
                                                        deselectLabel="Presiona para remover"
                                                    >
                                                        <template v-slot:noOptions>
                                                            <p>No hay opciones</p>
                                                        </template>
                                                        <template v-slot:noResult>
                                                            <p>No se encuentra coincidencia</p>
                                                        </template>
                                                    </multiselect>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="curso">Curso:</label>
                                                    <b-form-radio-group 
                                                        v-model="datos.curso" 
                                                        class="d-flex flex-column align-items-start border border-primary rounded p-2"
                                                        name="curso"
                                                    >
                                                        <b-form-radio value="1">1ro medio</b-form-radio>
                                                        <b-form-radio value="2">2do medio</b-form-radio>
                                                        <b-form-radio value="3">3ro medio</b-form-radio>
                                                        <b-form-radio value="4">4to medio</b-form-radio>
                                                        <b-form-radio value="Egresado">Egresado</b-form-radio>
                                                        <b-form-radio value="''">En blanco</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                            </div>
                                        </div>
                                    </tab-content>
                                    <tab-content title="Confirmación">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label for="pais"> Carrera:</label>
                                                    <multiselect
                                                        ref="msCarrera"
                                                        v-model="datos.carrera"
                                                        :options="carrerasFiltradas"
                                                        :searchable="true"
                                                        selectLabel="Presiona para seleccionar"
                                                        selectedLabel="Seleccionado"
                                                        deselectLabel="Presiona para remover"
                                                        placeholder="Selecciona carrera"
                                                        :custom-label="carreraLabel"
                                                    >
                                                        <template v-slot:noOptions>
                                                            <p>No hay opciones</p>
                                                        </template>
                                                        <template v-slot:noResult>
                                                            <p>No se encuentra coincidencia</p>
                                                        </template>
                                                    </multiselect>
                                                    <!-- <b-form-input v-model="datos.sede" class="border-primary"></b-form-input> -->
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="text-center">
                                                    <h2 class="mt-0">
                                                        <i class="mdi mdi-check-all text-success"></i>
                                                    </h2>
                                                    <h3 class="mt-0">¡Gracias por completar la información!</h3>
                                                </div>
                                                <div class="pt-4 pb-4 px-2 bg-light">
                                                    <div class="">
                                                        <div class="row mt-3">
                                                            <div class="offset-md-1 col-md-5">
                                                                <p><b>Rut/Pasaporte: {{ this.datos.rut }}</b></p>
                                                                <p><b>Nombre Completo: {{ this.datos.nombres }} {{ this.datos.apellido_paterno }} {{ this.datos.apellido_materno }}</b></p>
                                                                <p><b>Curso: {{ this.datos.curso }}</b></p>
                                                                <p><b>E-mail: {{ this.datos.email }}</b></p>
                                                            </div>
                                                            <div class="col-md-5">
                                                                <p><b>Fecha de Nacimiento: {{ this.datos.dia_nacimiento }}-{{ this.datos.mes_nacimiento }}-{{ this.datos.anio_nacimiento }}</b></p>
                                                                <p><b>Colegio: {{ colegioseleccionada ? ((colegioseleccionada.rbd || '') + '-' + (colegioseleccionada.nombre || '')) : '' }}</b></p>
                                                                <p><b>Celular: {{ this.datos.celular }}</b></p>
                                                                <p><b>Carrera: {{ this.datos.carrera?datos.carrera.nombre:'' }}</b></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="text-primary">*Si la información está correcta presiona "Finalizar"</p>
                                            </div>
                                        </div>
                                    </tab-content>
                                </form-wizard>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<style scoped>
.card-body {
  position: relative;
  min-height: 700px; /* mantiene altura base del wizard */
  max-height: 700px; /* evita que crezca más en el último paso */
  overflow-y: auto;  /* scroll interno si el contenido excede */
  overflow-x: visible;
  padding-bottom: 2rem;
}

/* asegura que el dropdown se vea completo */
.multiselect__content-wrapper {
  max-height: 300px !important;
  overflow-y: auto !important;
  z-index: 9999 !important;
}

/* evita que el wizard estire el contenedor */
.vue-form-wizard {
  height: 100%;
}

/* permite que los dropdowns no se corten */
.multiselect {
  position: relative;
  z-index: 10;
}

/* estiliza el tab de confirmación para que no tenga tanto espacio */
.tab-content:last-child .card.bg-light {
  max-width: 800px;
  margin: 0 auto;
}
.input-error {
  border: 2px solid #dc3545 !important; /* rojo Bootstrap */
  border-radius: 0.25rem; /* opcional, mantener estilo Bootstrap */
}
.image-container1,
.image-container2 {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow: hidden;
}

.image-container1 img,
.image-container2 img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
}

/* Lupa */
.lens1,
.lens2 {
    position: absolute;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    pointer-events: none;
    background-repeat: no-repeat;
    background-size: 200% 200%; /* IMPORTANTE para el zoom */
    border: 2px solid #00000055;
    display: none;
}
.mi-card {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
}
</style>